document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFiltros();
  initOrdenPrecioAtajos();
  initGaleriaProducto();
  initZoomProducto();
  initVariantesProducto();
  initCantidadProducto();
  initContadores();
  initCompartirProducto();
  initDescripcionProducto();
  initDescripcionLarga();
  initAgregarRapidoCarrito();
  initCarruselSugerencias();
});

function initCarruselSugerencias() {
  var carruseles = document.querySelectorAll('.mt-carrito-sugerencias__carrusel');
  carruseles.forEach(function (carrusel) {
    var lista = carrusel.querySelector('[data-mt-sugerencias-lista]');
    var flechaAnterior = carrusel.querySelector('[data-mt-sugerencias-flecha="anterior"]');
    var flechaSiguiente = carrusel.querySelector('[data-mt-sugerencias-flecha="siguiente"]');
    if (!lista || !flechaAnterior || !flechaSiguiente) return;

    var itemsReales = Array.prototype.slice.call(lista.querySelectorAll('.mt-carrito-sugerencias__item'));
    var totalReal = itemsReales.length;
    if (totalReal < 2) return;

    // Cuántos productos entran a la vez en el ancho visible. Se clona esa
    // misma cantidad a cada lado (los últimos al inicio, los primeros al
    // final) para que la pantalla nunca se quede con un hueco vacío al
    // acercarse a una punta, y el salto de vuelta a los productos reales
    // quede invisible porque el clon es idéntico.
    var estilos = getComputedStyle(lista);
    var gap = parseFloat(estilos.columnGap || estilos.gap || 16);
    var anchoItem = itemsReales[0].getBoundingClientRect().width + gap;
    var visibles = Math.min(totalReal, Math.max(1, Math.ceil(lista.clientWidth / anchoItem) + 1));

    for (var i = 0; i < visibles; i++) {
      var clonInicio = itemsReales[totalReal - visibles + i].cloneNode(true);
      clonInicio.setAttribute('aria-hidden', 'true');
      lista.insertBefore(clonInicio, itemsReales[0]);
    }
    for (var j = 0; j < visibles; j++) {
      var clonFinal = itemsReales[j].cloneNode(true);
      clonFinal.setAttribute('aria-hidden', 'true');
      lista.appendChild(clonFinal);
    }

    var indiceActual = visibles;
    var animando = false;

    function saltarA(indice) {
      lista.style.scrollBehavior = 'auto';
      lista.scrollLeft = lista.children[indice].offsetLeft;
    }

    function irA(indice) {
      animando = true;
      lista.style.scrollBehavior = 'smooth';
      lista.scrollTo({ left: lista.children[indice].offsetLeft, behavior: 'smooth' });

      var yaTermino = false;
      function terminar() {
        if (yaTermino) return;
        yaTermino = true;
        lista.removeEventListener('scrollend', terminar);
        animando = false;
        if (indiceActual >= visibles + totalReal) {
          indiceActual -= totalReal;
          saltarA(indiceActual);
        } else if (indiceActual < visibles) {
          indiceActual += totalReal;
          saltarA(indiceActual);
        }
      }
      lista.addEventListener('scrollend', terminar);
      // Respaldo por si el navegador no dispara "scrollend".
      setTimeout(terminar, 600);
    }

    flechaSiguiente.addEventListener('click', function () {
      if (animando) return;
      indiceActual += 1;
      irA(indiceActual);
    });

    flechaAnterior.addEventListener('click', function () {
      if (animando) return;
      indiceActual -= 1;
      irA(indiceActual);
    });

    window.addEventListener('resize', function () {
      saltarA(indiceActual);
    });

    saltarA(indiceActual);
  });
}

function initAgregarRapidoCarrito() {
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-mt-agregar-rapido]');
    if (!boton || boton.classList.contains('is-agregando')) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = boton.getAttribute('data-variant-id');
    if (!variantId) return;

    boton.classList.add('is-agregando');

    var estaEnPaginaCarrito =
      window.routes && window.routes.cart_url && window.location.pathname.indexOf(window.routes.cart_url) === 0;
    var cartDrawer = estaEnPaginaCarrito ? null : document.querySelector('cart-drawer');
    var cartNotification = estaEnPaginaCarrito ? null : document.querySelector('cart-notification');
    var cart = cartDrawer || cartNotification;

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (r) {
        return r.json();
      })
      .then(function (respuesta) {
        boton.classList.remove('is-agregando');
        if (respuesta.status) {
          console.error(respuesta.description || respuesta.message);
          return;
        }
        if (estaEnPaginaCarrito) {
          window.location.reload();
          return;
        } else if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(respuesta);
          if (typeof cart.open === 'function') cart.open();
        } else {
          window.location = window.routes.cart_url;
          return;
        }
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'mt-agregar-rapido',
              productVariantId: variantId,
              cartData: respuesta,
            });
          }
        } catch (err) {
          /* pubsub opcional, no bloquea el flujo principal */
        }
      })
      .catch(function (err) {
        boton.classList.remove('is-agregando');
        console.error(err);
      });
  });
}

function initDescripcionProducto() {
  var bloques = document.querySelectorAll('[data-mt-descripcion]');
  bloques.forEach(function (bloque) {
    var boton = bloque.querySelector('[data-mt-descripcion-boton]');
    var contenido = bloque.querySelector('[data-mt-descripcion-contenido]');
    if (!boton || !contenido) return;

    boton.addEventListener('click', function () {
      var abierto = boton.getAttribute('aria-expanded') === 'true';
      boton.setAttribute('aria-expanded', String(!abierto));
      contenido.hidden = abierto;
      bloque.classList.toggle('is-abierto', !abierto);
    });
  });
}

function initDescripcionLarga() {
  var ALTURA_MINIMA = 130;
  var bloques = document.querySelectorAll('[data-mt-descripcion-larga]');
  bloques.forEach(function (bloque) {
    var texto = bloque.querySelector('[data-mt-descripcion-texto]');
    var boton = bloque.querySelector('[data-mt-descripcion-boton-vermas]');
    var etiqueta = bloque.querySelector('[data-mt-descripcion-vermas-texto]');
    if (!texto || !boton) return;
    var textoVerMas = etiqueta ? etiqueta.textContent : '';

    function alturaColapsada() {
      // Si hay una imagen (ej. el GIF del producto) cerca del inicio, se
      // muestra completa (nunca cortada a la mitad); si no, se usa un
      // mínimo de un par de párrafos de texto.
      var img = texto.querySelector('img');
      if (img) {
        return Math.max(ALTURA_MINIMA, img.offsetTop + img.offsetHeight + 16);
      }
      return ALTURA_MINIMA;
    }

    function colapsar() {
      texto.style.maxHeight = alturaColapsada() + 'px';
    }

    function activarSiHaceFalta() {
      colapsar();
      if (texto.scrollHeight <= alturaColapsada() + 4) {
        boton.hidden = true;
        return;
      }
      boton.hidden = false;
    }

    (function () {
      var img = texto.querySelector('img');
      activarSiHaceFalta();
      if (img && !img.complete) {
        img.addEventListener('load', activarSiHaceFalta);
      }

      boton.addEventListener('click', function () {
        var abierto = bloque.classList.toggle('is-expandida');
        boton.setAttribute('aria-expanded', String(abierto));
        if (etiqueta) {
          etiqueta.textContent = abierto ? 'Ver menos' : textoVerMas;
        }
        if (abierto) {
          texto.style.maxHeight = texto.scrollHeight + 'px';
        } else {
          colapsar();
          texto.scrollIntoView({ block: 'nearest' });
        }
      });
    })();
  });
}

function initCompartirProducto() {
  var botones = document.querySelectorAll('[data-mt-compartir]');
  botones.forEach(function (boton) {
    boton.addEventListener('click', function () {
      var titulo = boton.getAttribute('data-titulo') || document.title;
      var url = boton.getAttribute('data-url') || window.location.href;

      if (navigator.share) {
        navigator.share({ title: titulo, url: url }).catch(function () {});
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(url)
          .then(function () {
            mostrarTextoCopiado(boton);
          })
          .catch(function () {
            window.prompt('Copia este enlace:', url);
          });
      } else {
        window.prompt('Copia este enlace:', url);
      }
    });
  });

  function mostrarTextoCopiado(boton) {
    var span = boton.querySelector('span');
    if (!span) return;
    var textoOriginal = span.textContent;
    span.textContent = boton.getAttribute('data-texto-copiado') || textoOriginal;
    boton.classList.add('is-copiado');
    setTimeout(function () {
      span.textContent = textoOriginal;
      boton.classList.remove('is-copiado');
    }, 2000);
  }
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      el.classList.add('mt-visible');
    });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) {
    observer.observe(el);
  });
}

function initFiltros() {
  var contenedores = document.querySelectorAll('[data-mt-catalogo]');
  contenedores.forEach(function (contenedor) {
    var botones = contenedor.querySelectorAll('.mt-filtro');
    var tarjetas = contenedor.querySelectorAll('.mt-card');
    if (!botones.length) return;
    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        botones.forEach(function (b) {
          b.classList.remove('is-active');
        });
        boton.classList.add('is-active');
        var filtro = boton.getAttribute('data-filtro');
        var visibles = 0;
        tarjetas.forEach(function (tarjeta) {
          var coincide = filtro === 'todos' || tarjeta.getAttribute('data-categoria') === filtro;
          tarjeta.style.display = coincide ? '' : 'none';
          if (coincide) visibles++;
        });
        var vacio = contenedor.querySelector('.mt-catalogo__vacio');
        if (vacio) vacio.style.display = visibles === 0 ? '' : 'none';
      });
    });
  });
}

function initOrdenPrecioAtajos() {
  var enlaces = document.querySelectorAll('[data-mt-orden-precio]');
  if (!enlaces.length) return;
  var sortActual = new URL(window.location.href).searchParams.get('sort_by');
  enlaces.forEach(function (enlace) {
    if (enlace.getAttribute('data-mt-orden-precio') === sortActual) {
      enlace.classList.add('is-active');
    }
    enlace.addEventListener('click', function (event) {
      event.preventDefault();
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', enlace.getAttribute('data-mt-orden-precio'));
      window.location.href = url.toString();
    });
  });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = Array.prototype.slice.call(galeria.querySelectorAll('.mt-producto__miniatura'));
    var flechaAnterior = galeria.querySelector('[data-mt-flecha="anterior"]');
    var flechaSiguiente = galeria.querySelector('[data-mt-flecha="siguiente"]');
    if (!principal || !miniaturas.length) return;

    var indiceActual = miniaturas.findIndex(function (m) {
      return m.classList.contains('is-active');
    });
    if (indiceActual < 0) indiceActual = 0;

    function mostrar(indice) {
      var total = miniaturas.length;
      indiceActual = ((indice % total) + total) % total;
      var mini = miniaturas[indiceActual];
      var src = mini.getAttribute('data-full');
      if (src) principal.querySelector('img').setAttribute('src', src);
      miniaturas.forEach(function (m) {
        m.classList.remove('is-active');
      });
      mini.classList.add('is-active');
      if (principal._mtZoomReset) principal._mtZoomReset();
    }

    miniaturas.forEach(function (mini, i) {
      mini.addEventListener('click', function () {
        mostrar(i);
      });
    });

    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function () {
        mostrar(indiceActual - 1);
      });
    }
    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function () {
        mostrar(indiceActual + 1);
      });
    }

    var inicioX = 0;
    var inicioY = 0;
    var arrastrando = false;
    var UMBRAL_SWIPE = 40;

    principal.addEventListener(
      'touchstart',
      function (e) {
        if (miniaturas.length < 2 || e.touches.length !== 1) return;
        if ((principal._mtZoomEscala || 1) > 1) return;
        var toque = e.touches[0];
        inicioX = toque.clientX;
        inicioY = toque.clientY;
        arrastrando = true;
      },
      { passive: true }
    );

    principal.addEventListener('touchend', function (e) {
      if (!arrastrando) return;
      arrastrando = false;
      if ((principal._mtZoomEscala || 1) > 1) return;
      var toque = e.changedTouches[0];
      var deltaX = toque.clientX - inicioX;
      var deltaY = toque.clientY - inicioY;
      if (Math.abs(deltaX) < UMBRAL_SWIPE || Math.abs(deltaX) < Math.abs(deltaY)) return;
      if (deltaX < 0) {
        mostrar(indiceActual + 1);
      } else {
        mostrar(indiceActual - 1);
      }
    });
  });
}

function initZoomProducto() {
  var esTactil = window.matchMedia('(pointer: coarse)').matches;
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    if (esTactil) {
      initZoomTactilEnLinea(galeria);
    } else {
      initZoomOverlayEscritorio(galeria);
    }
  });
}

/* Escritorio: click abre un overlay con efecto lupa que sigue al mouse. */
function initZoomOverlayEscritorio(galeria) {
  var overlay = galeria.parentElement ? galeria.parentElement.querySelector('[data-mt-zoom-overlay]') : null;
  var btnAbrir = galeria.querySelector('[data-mt-zoom-abrir]');
  var imgPrincipal = galeria.querySelector('[data-mt-imagen-principal] img');
  if (!overlay || !btnAbrir || !imgPrincipal) return;

  var btnCerrar = overlay.querySelector('[data-mt-zoom-cerrar]');
  var lienzo = overlay.querySelector('[data-mt-zoom-lienzo]');
  var imgZoom = overlay.querySelector('[data-mt-zoom-img]');
  var ayuda = overlay.querySelector('[data-mt-zoom-ayuda]');
  if (!lienzo || !imgZoom) return;

  if (ayuda) ayuda.textContent = 'Mueve el mouse sobre la imagen para acercar';

  function urlZoomActual() {
    var miniaturaActiva = galeria.querySelector('.mt-producto__miniatura.is-active');
    if (miniaturaActiva && miniaturaActiva.getAttribute('data-zoom')) {
      return miniaturaActiva.getAttribute('data-zoom');
    }
    return imgPrincipal.getAttribute('data-zoom') || imgPrincipal.getAttribute('src');
  }

  function abrir() {
    imgZoom.src = urlZoomActual();
    imgZoom.alt = imgPrincipal.alt || '';
    imgZoom.style.transformOrigin = '50% 50%';
    imgZoom.style.transform = 'scale(1)';
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function cerrar() {
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  btnAbrir.addEventListener('click', abrir);
  imgPrincipal.style.cursor = 'zoom-in';
  imgPrincipal.addEventListener('click', abrir);
  if (btnCerrar) btnCerrar.addEventListener('click', cerrar);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) cerrar();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) cerrar();
  });

  lienzo.addEventListener('mousemove', function (e) {
    var rect = lienzo.getBoundingClientRect();
    var px = ((e.clientX - rect.left) / rect.width) * 100;
    var py = ((e.clientY - rect.top) / rect.height) * 100;
    imgZoom.style.transformOrigin = px + '% ' + py + '%';
    imgZoom.style.transform = 'scale(2.2)';
  });
  lienzo.addEventListener('mouseleave', function () {
    imgZoom.style.transform = 'scale(1)';
  });
}

/* Celular: zoom en línea directo sobre la misma imagen (pellizcar/arrastrar), sin overlay. */
function initZoomTactilEnLinea(galeria) {
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var imgPrincipal = principal ? principal.querySelector('img') : null;
  var btnAbrir = galeria.querySelector('[data-mt-zoom-abrir]');
  var overlay = galeria.parentElement ? galeria.parentElement.querySelector('[data-mt-zoom-overlay]') : null;
  if (!principal || !imgPrincipal) return;

  if (btnAbrir) btnAbrir.style.display = 'none';
  if (overlay) overlay.remove();
  principal.style.touchAction = 'pan-y';

  var escala = 1;
  var trasladoX = 0;
  var trasladoY = 0;

  function limitarTraslado() {
    var maxX = (principal.clientWidth * (escala - 1)) / 2;
    var maxY = (principal.clientHeight * (escala - 1)) / 2;
    trasladoX = Math.min(Math.max(trasladoX, -maxX), maxX);
    trasladoY = Math.min(Math.max(trasladoY, -maxY), maxY);
  }

  function aplicarTransform(animado) {
    imgPrincipal.style.transition = animado ? 'transform 0.2s ease-out' : 'none';
    imgPrincipal.style.transform = 'translate(' + trasladoX + 'px, ' + trasladoY + 'px) scale(' + escala + ')';
    principal._mtZoomEscala = escala;
    principal.style.touchAction = escala > 1 ? 'none' : 'pan-y';
  }

  function restablecer(animado) {
    escala = 1;
    trasladoX = 0;
    trasladoY = 0;
    aplicarTransform(animado);
  }

  principal._mtZoomReset = function () {
    restablecer(false);
  };

  var distanciaInicial = 0;
  var escalaInicial = 1;
  var arrastrandoUnDedo = false;
  var inicioArrastreX = 0;
  var inicioArrastreY = 0;
  var trasladoInicialX = 0;
  var trasladoInicialY = 0;
  var ultimoTap = 0;
  var centroInicialX = 0;
  var centroInicialY = 0;

  function distanciaEntreToques(toques) {
    var dx = toques[0].clientX - toques[1].clientX;
    var dy = toques[0].clientY - toques[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  principal.addEventListener(
    'touchstart',
    function (e) {
      if (e.touches.length === 2) {
        distanciaInicial = distanciaEntreToques(e.touches);
        escalaInicial = escala;
        centroInicialX = trasladoX;
        centroInicialY = trasladoY;
        arrastrandoUnDedo = false;
      } else if (e.touches.length === 1 && escala > 1) {
        arrastrandoUnDedo = true;
        inicioArrastreX = e.touches[0].clientX;
        inicioArrastreY = e.touches[0].clientY;
        trasladoInicialX = trasladoX;
        trasladoInicialY = trasladoY;
      }
    },
    { passive: true }
  );

  principal.addEventListener(
    'touchmove',
    function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        var distanciaActual = distanciaEntreToques(e.touches);
        if (distanciaInicial > 0) {
          escala = Math.min(Math.max(escalaInicial * (distanciaActual / distanciaInicial), 1), 4);
          trasladoX = centroInicialX;
          trasladoY = centroInicialY;
          limitarTraslado();
          aplicarTransform(false);
        }
      } else if (e.touches.length === 1 && arrastrandoUnDedo) {
        e.preventDefault();
        trasladoX = trasladoInicialX + (e.touches[0].clientX - inicioArrastreX);
        trasladoY = trasladoInicialY + (e.touches[0].clientY - inicioArrastreY);
        limitarTraslado();
        aplicarTransform(false);
      }
    },
    { passive: false }
  );

  principal.addEventListener('touchend', function (e) {
    if (e.touches.length === 0) {
      arrastrandoUnDedo = false;
      distanciaInicial = 0;
      if (escala <= 1.02) {
        restablecer(true);
      }
      var ahora = Date.now();
      if (ahora - ultimoTap < 300) {
        restablecer(true);
      }
      ultimoTap = ahora;
    }
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = form.querySelector('input[name="id"]');
    var contenedorInfo = form.closest('.mt-producto__info') || form;
    var precioEl = contenedorInfo.querySelector('[data-mt-precio]');
    var precioTachadoEl = contenedorInfo.querySelector('[data-mt-precio-tachado]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');
    var grupos = form.querySelectorAll('[data-mt-opcion-grupo]');

    function variedadSeleccionada() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.is-active');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return variantes.find(function (v) {
        return v.opciones.every(function (op, i) {
          return op === seleccion[i];
        });
      });
    }

    function formatoMoneda(centavos) {
      return (
        '$' +
        Math.round(centavos / 100)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      );
    }

    function actualizar() {
      var variante = variedadSeleccionada();
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.precio);
      if (precioTachadoEl) {
        if (variante.precioComparado && variante.precioComparado > variante.precio) {
          precioTachadoEl.textContent = formatoMoneda(variante.precioComparado);
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        var textoBoton = botonComprar.querySelector('span');
        if (variante.disponible) {
          botonComprar.disabled = false;
          botonComprar.removeAttribute('aria-disabled');
          if (textoBoton) textoBoton.textContent = botonComprar.getAttribute('data-texto-disponible');
        } else {
          botonComprar.disabled = true;
          if (textoBoton) textoBoton.textContent = botonComprar.getAttribute('data-texto-agotado');
        }
      }
      if (variante.imagenUrl) {
        var raizProducto = form.closest('.mt-producto');
        var galeria = raizProducto ? raizProducto.querySelector('[data-mt-galeria]') : null;
        if (galeria) {
          var imgPrincipal = galeria.querySelector('[data-mt-imagen-principal] img');
          if (imgPrincipal) imgPrincipal.setAttribute('src', variante.imagenUrl);
          var miniaturas = galeria.querySelectorAll('.mt-producto__miniatura');
          miniaturas.forEach(function (m) {
            m.classList.toggle('is-active', m.getAttribute('data-full') === variante.imagenUrl);
          });
        }
      }
    }

    grupos.forEach(function (grupo) {
      var pills = grupo.querySelectorAll('.mt-producto__pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('is-disabled')) return;
          pills.forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initCantidadProducto() {
  var cantidades = document.querySelectorAll('[data-mt-cantidad]');
  cantidades.forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-mt-menos]');
    var mas = wrap.querySelector('[data-mt-mas]');
    if (!input) return;
    if (menos)
      menos.addEventListener('click', function () {
        var v = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.value = v;
      });
    if (mas)
      mas.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10) + 1;
        input.value = v;
      });
  });
}

function initContadores() {
  var contadores = document.querySelectorAll('[data-mt-contador]');
  if (!contadores.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var fin = parseInt(el.getAttribute('data-mt-contador'), 10) || 0;
        var duracion = 900;
        el.textContent = '0';
        var inicio = performance.now();
        function paso(ahora) {
          var progreso = Math.min((ahora - inicio) / duracion, 1);
          el.textContent = Math.round(progreso * fin);
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  contadores.forEach(function (el) {
    observer.observe(el);
  });
}
